import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { Field } from '../../../models/chips-and-fields';

@Component({
  selector: 'app-radio-standard',
  templateUrl: './radioStandard.component.html',
  styleUrls: ['./radioStandard.component.css']
})
export class RadioStandardComponent implements OnInit {

  @Input() public field: Field;
  @Input() public parentFormGroup: FormGroup;

  constructor() { }

  ngOnInit() {
  }

}
